import Rive from "@rive-app/react-canvas";

export const DaniiBTCBannerMoving = () => (
  <Rive src="/rive/DanialBanner.riv" stateMachines="State Machine 1" />
);
